/**
 * Moved to `shared/src/review/non-competitor-domains.ts` so the review surface and the server-side
 * export read one copy of this logic. Edit it there.
 *
 * Named rather than `export *`: the Vite dev server's CommonJS interop runs a
 * star re-export before the module it re-exports has loaded.
 */
export {
  NON_COMPETITOR_DOMAINS,
  isNonCompetitorDomain
} from '@taptimize/shared/dist/review/non-competitor-domains';
